import { useSelector } from "react-redux";

import { getCollectionPointBillingStatus } from "../../../selectors/collectionPoint";
import { BillingStatus } from "../../../types/billings";
import { BillingPayments } from "./BillingPayments";
import { BillingPaymentSchedule } from "./BillingPaymentSchedule/BillingPaymentSchedule";

import styles from "./CollectionPointBilling.module.scss";

export const CollectionPointBilling = () => {
  const billingStatus = useSelector(getCollectionPointBillingStatus);

  if (billingStatus === null) {
    return null;
  }

  return (
    <div className={styles.container}>
      {billingStatus === BillingStatus.New && <BillingPaymentSchedule />}
      {(billingStatus === BillingStatus.Active || billingStatus === BillingStatus.Closed) && <BillingPayments />}
    </div>
  );
};
